export const sidebarId = "sidebar";

export const SIGNED_32BIT_INT_MAX_VALUE = 1_000_000_000;
export const SIGNED_32BIT_INT_MIN_VALUE = -1_000_000_000;

export const HP_TEMP_VALUE = {
  MAX: 999,
  MIN: 0,
};

export const HP_BONUS_VALUE = {
  MAX: 99,
  MIN: -99,
};

export const HP_OVERRIDE_MAX_VALUE = 999;

export const HP_BASE_MAX_VALUE = 500;

export const HP_DAMAGE_TAKEN_VALUE = {
  MAX: SIGNED_32BIT_INT_MAX_VALUE,
  MIN: 0,
};
